// External
import { Component, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';
import { UiForm } from '../ui-form.models';
import { UiIcon } from '../../ui-icon/ui-icon.models';
import { ConfigService } from 'src/app/common/config/config.service';

// Internal

@Component({
  selector: 'switch-control',
  template: `
            <ng-content select="input"></ng-content>
            <div class="switch-div">
                <div class="switch-circle">
                    <ui-icon *ngIf="icon" [type]="icon.type" [icon]="icon.value" [size]="16" color="primary" shape="icon"></ui-icon>
                    <ui-icon class="icon-on" *ngIf="iconOn" [type]="iconOn.type" [icon]="iconOn.value" [size]="16" shape="icon"></ui-icon>
                    <ui-icon class="icon-off" *ngIf="iconOff" [type]="iconOff.type" [icon]="iconOff.value" [size]="16" shape="icon"></ui-icon>
                </div>
            </div>
            <ng-content select="label"></ng-content>
            <div class="prefix" *ngIf="addons && addons.indexOf('prefix') != -1"><ng-content select="[prefix]"></ng-content></div>
            <div class="suffix" *ngIf="addons && addons.indexOf('suffix') != -1"><ng-content select="[suffix]"></ng-content></div>
            `,
  host: {
      '[class.switch-control]': 'true'
  }
})

export class SwitchControlComponent implements OnInit, UiForm.SwitchControl.Component {

    @Input() orientation = UiForm.Orientation.LTR;
    @Input() alignment = UiForm.Alignment.CENTER;
    @Input() addons: UiForm.SwitchControl.Addons;
    @Input() icon: UiIcon.Svg;
    @Input() iconOn: UiIcon.Svg;
    @Input() iconOff: UiIcon.Svg;

    constructor(private el: ElementRef, private rendered: Renderer2, public readonly configService: ConfigService ) {}

    ngOnInit() {
        this.rendered.addClass(this.el.nativeElement, this.orientation);
        this.rendered.addClass(this.el.nativeElement, 'align-items-' + this.alignment);

        if (this.icon) {
            this.iconOn = null;
            this.iconOff = null;
        }
    }
}
